import { render, staticRenderFns } from "./DeliveryForm.vue?vue&type=template&id=13a20742&scoped=true"
import script from "./DeliveryForm.vue?vue&type=script&lang=js"
export * from "./DeliveryForm.vue?vue&type=script&lang=js"
import style0 from "./DeliveryForm.vue?vue&type=style&index=0&id=13a20742&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a20742",
  null
  
)

export default component.exports